module.exports = __webpack_public_path__ + "img/pethouse17.5faaa95d.jpg";